import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getCorporateFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How does food ${vehicleType} office catering work in ${cityName}?`,
    answer: `Office catering with food ${vehicleType}s is simple through ${siteTitle}. You submit details like date, location, headcount, and budget, and available food ${vehicleType}s respond with menu options and pricing. Trucks can serve directly from the ${vehicleType} or set up food indoors, depending on your office and preferences. You compare quotes, message vendors, and book — all in one place.`
  },
  {
    question: `How much does office food ${vehicleType} catering cost?`,
    answer: `Office food ${vehicleType} catering costs depend on the number of employees, menu selection, and service style. Many office lunches fall in the range of a few hundred to a few thousand dollars. ${siteTitle} lets you compare real quotes from food ${vehicleType}s so you can stay on budget with no added service fees or commissions.`
  },
  {
    question: `Are food ${vehicleType}s a good option for corporate office lunches?`,
    answer: `Yes. Food ${vehicleType}s are a popular alternative to traditional office catering because they offer fresh, made-to-order meals, more variety, and a fun experience for employees. They work well for team lunches, employee appreciation events, onboarding days, and recurring office lunch programs.`
  },
  {
    question: `Can food ${vehicleType}s handle dietary restrictions for office catering?`,
    answer: `Absolutely. Many food ${vehicleType}s offer vegetarian, vegan, gluten-free, dairy-free, and allergy-conscious options. When submitting your request, you can note dietary needs, and we'll connect you with vendors that can accommodate your team's preferences.`
  },
  {
    question: `Can food ${vehicleType}s cater recurring office lunches or weekly programs?`,
    answer: `Yes. ${siteTitle} is commonly used for recurring office lunch programs, such as weekly or monthly food ${vehicleType} visits. Many companies rotate different food ${vehicleType}s to keep things fresh while maintaining a predictable schedule and budget.`
  },
  {
    question: `What space or setup is needed for office food ${vehicleType} catering?`,
    answer: `Food ${vehicleType}s are flexible and can often serve from parking lots, loading areas, or nearby curb space. Some ${vehicleType}s can also set up buffet-style service indoors if needed. If you're unsure about access, power, or setup, our team can help coordinate details with the vendor.`
  }
];

function CorporateFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getCorporateFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default CorporateFaq;
